import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HelperFunctionsService } from '../helpers/helper-functions.service';
import { TranslateModule } from '@ngx-translate/core';
import { Store } from '@ngxs/store';

@Component({
  selector: 'lib-puzzle-landscape-message',
  templateUrl: './puzzle-landscape-message.component.html',
  styleUrls: ['./puzzle-landscape-message.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule],
})
export class PuzzleLandscapeMessageComponent implements OnInit {
  heightIsBelowLimit = false;
  private mobileMinLandscapeHeight: number;

  constructor(
    private el: ElementRef,
    private helperFunctions: HelperFunctionsService,
    private store: Store,
    private cd: ChangeDetectorRef
  ) {
    // We need to move the adContainer outside of app-root so we can have a higher z-index than the ionic.

    let appRoot;

    if (document.querySelector('krupion-puzzle-app-root')) {
      appRoot = document.getElementsByTagName('krupion-puzzle-app-root')[0];
    } else if (document.querySelector('krupion-puzzle-webcomponent')) {
      appRoot = document.getElementsByTagName('krupion-puzzle-webcomponent')[0];
    }

    const element = this.el.nativeElement;

    element.parentElement.removeChild(element);
    appRoot.parentElement.insertBefore(element, appRoot);

    this.store
      .select((state) => state.puzzleFrameworkConfig.mobileMinLandscapeHeight)
      .subscribe((height) => {
        this.mobileMinLandscapeHeight = height;
      });
  }

  @HostListener('window:resize')
  private checkForLandScapeMode() {
    if (this.helperFunctions.isMobileDevice() && this.mobileMinLandscapeHeight) {
      const minHeight = this.mobileMinLandscapeHeight;
      const windowHeight = window.document.body.offsetHeight;
      const windowWidth = window.document.body.offsetWidth;
      const landscape = windowWidth > windowHeight;
      const prohibit = landscape && windowHeight < minHeight;
      if (prohibit) {
        this.heightIsBelowLimit = prohibit;
        this.cd.detectChanges();
      } else {
        this.heightIsBelowLimit = false;
        this.cd.detectChanges();
      }
    } else {
      this.heightIsBelowLimit = false;
      this.cd.detectChanges();
    }
  }

  ngOnInit(): void {
    this.checkForLandScapeMode();
  }
}
